import React from 'react'
import styled from 'styled-components'
import { Media, mbSize } from '../../theme'
import noteIcon from './image/note.webp'
const TipContainer = styled.div`
  padding: 24px;
  border-radius: 4px;
  border: 1px solid #ffd6ce;
  border-radius: 10px;
  background: #ffefec;
`

const TipTitle = styled.div`
  font-weight: bold;
  font-size: 20px;
  color: #08090a;
  font-weight: bold;
  margin-left: 5px;
  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(32)};
    margin-left: ${mbSize(12)};
  }
`

const TipContent = styled.div`
  font-size: 16px;
  line-height: 26px;
  color: #460d00;
  ${Media.lessThan(Media.small)} {
    font-size: ${mbSize(24)};
    line-height: ${mbSize(44)};
  }
`

const TitleWrapper = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 12px;
  ${Media.lessThan(Media.small)} {
    margin-bottom: ${mbSize(32)};
  }
`

const NoteIcon = styled.img`
  width: 23px;
`

export interface TipProps {
  title?: string
  content: string
  titleAttributes?: Record<string, string>
  contentAttributes?: Record<string, string>
}

export const Tip: React.FC<TipProps> = ({
  title,
  content,
  titleAttributes,
  contentAttributes,
  ...props
}) => {
  return (
    <TipContainer {...props}>
      <TitleWrapper>
        <NoteIcon src={noteIcon} alt='tip' />
        {title && <TipTitle {...titleAttributes} dangerouslySetInnerHTML={{ __html: title }} />}
      </TitleWrapper>
      <TipContent {...contentAttributes} dangerouslySetInnerHTML={{ __html: content }} />
    </TipContainer>
  )
}
